import { combineReducers } from 'redux';
import mainPromotion from './PromotionsReducers';
import singlePromotions from './SinglePromotionsReducers';

const promotions = combineReducers({
    mainPromotion,
    singlePromotions,
});

export default promotions;
